import React from 'react'
import { Card } from 'primereact/card';
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import "../../Styles/pages/transactions.scss";
import "../../Styles/pages/payments.scss";
import { MultiSelect } from 'primereact/multiselect';
import { FormatCurrency, useCurrencyConstants } from '../../Components/CurrencyFormatter';
import { TreeSelectComponent } from '../../Components/TreeSelectComponent';
import { ProgressSpinner } from 'primereact/progressspinner';

export const ActionBar = ({
    planSelected,
    treeSelectRef,
    setState,
    state,
    loadingFn,
    segmentselected,
    setSegmentSelected,
    segmentoptions,
    tagSelected,
    setTagselected,
    tagOptions,
    plan,
    loading,
    exportItemsTemplate,
    downloadingUptakePdf,
    dropdownExportItems,
}) => {
    const { t } = useTranslation("common");

    const handleSegmentChange = (e) => {
        setSegmentSelected(e.value);
    };

    const handleTagChange = (e) => {
        const newSelections = e.value;
        const previousSelections = tagSelected;

        const addedItem = newSelections.find(item => !previousSelections.includes(item));

        if (addedItem) {
            const parentGroup = tagOptions.find(group =>
                group.items?.some(item => item.value === addedItem)
            );

            if (parentGroup) {
                const itemsInSameGroup = parentGroup.items.map(item => item.value);

                const filtered = newSelections.filter(value =>
                    !itemsInSameGroup.includes(value) || value === addedItem
                );
                setTagselected(filtered);
                return;
            }
        }
        setTagselected(newSelections);
    };

    const { currencyFormat, currencySymbol } = useCurrencyConstants();

    return (
        <div>
            <Card id="payment-action-bar" style={{ width: "auto" }}>
                <div className='col-12'>
                    <div className="p-grid p-fluid main-div">
                        <>
                            <div>
                                <div className="p-col-12 p-md-3 filters">
                                    <div className="p-inputgroup">
                                        <TreeSelectComponent
                                            ref={treeSelectRef}
                                            state={state}
                                            setState={setState}
                                            loadingFn={loadingFn}
                                            allowParentSelection={false}
                                            showValueItemInfo={false}
                                            placeholder={t("invitation.plan_select")}
                                            className="w-full tree_comp activity-dropdown"
                                            id="tree_select_comp"
                                        />
                                    </div>
                                </div>
                                <span className='p-mt-1 type_helper_div'>
                                    {t("report.select_plan")}
                                </span>
                            </div>

                            <div className="p-col-12 p-md-3 filters">
                                <div className="p-inputgroup" style={{ width: "auto" }}>
                                    <Dropdown
                                        value={segmentselected}
                                        options={segmentoptions}
                                        optionLabel="name"
                                        optionValue="id"
                                        placeholder={t("report.select_segment")}
                                        filter
                                        showClear
                                        onChange={handleSegmentChange}
                                        disabled={!planSelected}
                                        className="w-full activity-dropdown"
                                    />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-3 filters">
                                <div className="p-inputgroup" style={{ width: "auto" }}>
                                    <MultiSelect
                                        value={tagSelected}
                                        options={tagOptions}
                                        onChange={handleTagChange}
                                        optionLabel="label"
                                        optionGroupLabel="label"
                                        optionGroupChildren="items"
                                        placeholder={t("report.select_tag")}
                                        display="chip"
                                        filter
                                        disabled={!planSelected}
                                        id='multi-dropdown'
                                        className="w-full activity-dropdown custom-multiselect-checkbox"
                                        panelClassName="custom-tag-multiselect-panel"
                                    />
                                </div>
                            </div>
                        </>
                    </div>
                </div>

                {!loading && <section className='col-12 mx-2'>
                    <hr style={{ borderTop: "2px solid #e0e0e0" }} />
                    <main className='grid'>
                        <div className='col-3 md:col-3 sm:col-2'>
                            <div className='product_name'>{plan?.groupName}</div>
                            <div className='plan_name'>{plan?.name}</div>
                            <p className='plan_description-uptake'>{plan?.description}</p>
                        </div>
                        <div className='col-3 md:col-3 sm:col-2'>
                            <div className=''>
                                <div className="text-left policy mb-0">{plan?.policy === "FIXED" ? t("products.fixed_billing").toUpperCase() : plan?.policy === "CUSTOM" ? t("products.custom_billing").toUpperCase() : t('billing', { val: plan?.policy })}</div>
                                <div>
                                    <span className="planCost mt-0">
                                        {(plan?.policy === "CUSTOM" && !plan?.cost) ? t("amount_fixed") : (plan?.policy === "TARGET") ? t("products.target-fixed") : (plan?.policy === "FLEXIBLE") ? t("products.flexible-amount")
                                            : (plan?.policy === "FIXED" && plan?.cost &&
                                                <FormatCurrency
                                                    amount={plan?.cost}
                                                    currencySymbol={currencySymbol}
                                                    currencyFormat={currencyFormat}
                                                    className="plan-cost mt-0"
                                                />
                                            )
                                        }
                                    </span>
                                    {plan?.policy === "FIXED" && plan?.cost === null && <p></p>}
                                </div>
                                <div>
                                    <span className="planBillingPeriod pb-0 pt-0">
                                        {t(`product.${plan?.billingPeriod.toLowerCase()}`)}
                                    </span>
                                </div>
                                <div className='mt-1'>
                                    {plan?.deductions !== null && (
                                        plan?.cost === null && plan?.policy === "FIXED" ?
                                            null
                                            : <div className="text-left">
                                                <p id="deductions-text" style={{ color: "#23547B", fontSize: "12px", paddingRight: "0.2rem", fontWeight: "bold" }}>
                                                    {plan?.deductions > 1 ?
                                                        t("product.deduction-val_plural", { count: plan?.deductions })
                                                        : t("product.deduction-val", { count: plan?.deductions })}</p>
                                            </div>
                                    )}
                                </div>

                                <div className=''>
                                    <div>
                                        {plan?.setup && <div className="setup_fee_div" id="setup-m-b">
                                            <span className="setup_fee_tag">{t("common.setup_fee_label")}</span>
                                            <FormatCurrency
                                                amount={plan?.setup}
                                                currencySymbol={currencySymbol}
                                                currencyFormat={currencyFormat}
                                                className="setup_fee_valu"
                                            />
                                        </div>}
                                    </div>
                                    <div>
                                        {plan?.graceDays === null || plan?.graceDays === 0 ? "" :
                                            <div style={{ display: "flex", flexDirection: "row", paddingBottom: "0.2rem" }}>
                                                <span className="graceDaysLabel">{t("product.graceDaysLabel")}{":"}</span>
                                                <span className="planGraceDays">{plan?.graceDays} {" "}{plan?.graceDays ? t("products.day") : null}
                                                </span>
                                            </div>}
                                    </div>
                                    <div>
                                        {plan?.reminderDays === null || plan?.reminderDays === 0 ? <div></div> :
                                            <div style={{ display: "flex", flexDirection: "row" }}>
                                                <span className="reminderDaysLabel">{t("product.reminderDaysLabel")}{":"}</span>
                                                <span className="planReminderDays">{plan?.reminderDays}{" "}{plan?.reminderDays ? t("products.day") : null}</span>
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-6 md:col-6 sm:col-3 text-right'>
                            <div className='spin_div'>
                                {downloadingUptakePdf && <ProgressSpinner className='mr-0' style={{ width: '3rem', height: '2rem' }} />}
                                <Dropdown
                                    placeholder={t('export')}
                                    style={{ width: "145px" }}
                                    options={dropdownExportItems}
                                    optionLabel='name'
                                    itemTemplate={exportItemsTemplate}
                                    className='text-left items-center export-dropdown'
                                    id='export_drop'
                                >
                                </Dropdown>
                            </div>
                        </div>
                    </main>
                </section>}
            </Card>
        </div>
    );
};

